import { render, staticRenderFns } from "./pre-heading.vue?vue&type=template&id=5d1eeefb&scoped=true&"
import script from "./pre-heading.vue?vue&type=script&lang=js&"
export * from "./pre-heading.vue?vue&type=script&lang=js&"
import style0 from "./pre-heading.vue?vue&type=style&index=0&id=5d1eeefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1eeefb",
  null
  
)

export default component.exports